module.exports = __webpack_public_path__ + "assets/img/register_date-c376e864.png";